var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{attrs:{"id":"ot-sdk-cookie-policy"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }